var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"navWrap",staticClass:"tabs"},[_vm._l((_vm.tabList),function(item,index){return _c('div',{key:item.label,staticClass:"tab-item",style:({
      color: index === _vm.activeIndex ? _vm.activeColor : '#333',
      fontSize: _vm.fontSize
    }),on:{"click":function($event){return _vm.changeTab(index)}}},[_vm._t("content",function(){return [_vm._v(" "+_vm._s(item.label)+" ")]},{"tab":item})],2)}),_c('div',{ref:"tabLine",staticClass:"tab-line",style:(_vm.barStyle)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }